<template>
  <OrdersProvider>
    <template v-slot:default="{ weekDates, products, week, setWeek, submit, orders, loading, submittingOrders, errorOnSubmit, errorBag }">
      <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8 text-center mt-16 print:mt-0">
        <WeekNavigation :selected="week" @update="setWeek" :loading="loading" />
        <Filter />
        <DataTable
          :class="{
            'opacity-30 pointer-events-none': loading
          }">
          <template #head>
            <DataHeadRow :dates="weekDates" :orders="orders" />
          </template>
          <template #body>
            <ProductRow
              v-for="product in products"
              :key="product.item.id"
              :dates="weekDates"
              :item="product.item" />
          </template>
        </DataTable>
      </div>
      <OrderSummary @submit="submit">
        <template #toolbar="{ onOpen, onClose, active }">
          <OrderToolbar
            :active="active"
            :selected="week"
            :loading="loading"
            :submitting="submittingOrders > 0"
            @open="onOpen"
            @close="onClose" />
        </template>
        <CartContent />
        <OrderSubmit
          :submitting="submittingOrders > 0"
          :error-on-submit="errorOnSubmit"
          :error-bag="errorBag"
          @submit="submit" />
      </OrderSummary>
    </template>
  </OrdersProvider>
</template>

<script>
import { compareAsc } from 'date-fns'
import parseISO from 'date-fns/parseISO'

import OrdersProvider from '@/Components/WeekShop/OrdersProvider.vue'
import Filter from '@/Components/Filter/Filter'
import WeekNavigation from '@/Components/WeekShop/WeekNavigation.vue'
import OrderSummary from '@/Components/WeekShop/OrderSummary'

import DataTable from './modules/DataTable.vue'
import DataHeadRow from './modules/DataHeadRow.vue'
import ProductRow from './modules/ProductRow.vue'
import OrderToolbar from './Modules/OrderToolbar'
import CartContent from './Modules/CartContent'
import OrderSubmit from './Modules/OrderSubmit'

export default {
  components: {
    OrdersProvider,
    Filter,
    WeekNavigation,
    OrderSummary,
    DataTable,
    DataHeadRow,
    ProductRow,
    OrderToolbar,
    CartContent,
    OrderSubmit,
  },

  methods: {
    getOrderByDate(date) {
      return this.orders ? this.orders.find(order => order ? compareAsc(parseISO(order.date), date) === 0 : false) : {}
    },
  }
}
</script>
